import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((_theme) => ({
  mapActions: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: '8px',
  },
}));

export { useStyles };
